export const zeroWidthNonBreakingSpace = <>&#65279;</>;
